var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h3',[_vm._v("Statistica Ethicae Spinozae")])])}
var staticRenderFns = []

export { render, staticRenderFns }